/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Divider, CircularProgress, Card, TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Typography, InputAdornment,} from "@material-ui/core";
import PendingIcon from '@material-ui/icons/CancelTwoTone';
import CheckIcon from '@material-ui/icons/CheckCircleTwoTone';
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import C13DeliveryOrdersStatusDashboardFilter from "./chunks/C13DeliveryOrdersStatusDashboardFilter";
import DxGridTable from "../../../components/DxGridTable/DxGridTable";
import { IsEmpty } from "../../../utils/helper";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import HorizontalCards from "../../../components/HorizontalCardList/HorizontalCards";
import RefreshIcon from "mdi-material-ui/Refresh";
import SearchIcon from "@material-ui/icons/Search";



const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
  wrappedTableHeaders: {
    '& .MuiTableCell-head': {
      whiteSpace: 'normal !important',
      wordWrap: 'break-word !important',
      lineHeight: '1.3 !important',
      padding: '12px 8px !important',
      minWidth: '80px',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontSize: '0.875rem',
      fontWeight: 600,
      backgroundColor: '#1976d2 !important',
      color: '#ffffff !important',
      border: '1px solid #1565c0 !important',
    },
    '& .MuiTableCell-body': {
      border: '1px solid #e0e0e0 !important',
      padding: '8px !important',
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    '& .MuiTableRow-root:nth-child(even)': {
      backgroundColor: '#f5f5f5',
    },
    '& .MuiTableRow-root:hover': {
      backgroundColor: '#e3f2fd !important',
    },
  },
  // Status cell with green background
  statusCompleted: {
    backgroundColor: '#41D57F !important',
  },
  // Icon styles
  checkIcon: {
    color: '#ffffff',
    fontSize: '1.5rem',
    verticalAlign: 'middle',
  },
  pendingIconStyle: {
    color: '#f44336',
    fontSize: '1.5rem',
    verticalAlign: 'middle',
  },
});

class C14AllOrdersProgressDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showTableFilter: false,
      isActionLoading: false,
      searchText: "",
      searchTextError: "",
      categoriesData: [
        { id: -1, label: "All" },
        { id: 1, label: "In Progress" },
        { id: 2, label: "Delivered" },
        { id: 3, label: "Payment Received" },
        { id: 4, label: "Returned" },
        { id: 5, label: "Un-Delivered" },
        { id: 6, label: "Completed" },
      ],
      categoriesDataLoading: false,
      categoryId: -1,
      categoryIdError: "",
      ordersList: [],
      itemsList: [],
      isOpenChangeStatus: false,
      selectedOrder: {},
      changeStatusId: "",
      changeStatusIdError: "",
      changeOtherStatusId: "",
      changeOtherStatusIdError: "",
      changeStatusRemarks: "",
      changeStatusRemarksError: "",
      changeStatusLoading: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isLoginMenu: false,
      isReload: true,
      searchBar: "",
    };
  }

  componentDidMount() {
    this.getData(
      "GET",
      "/sales/C14SalesOrderView",
      null,
      "ordersList",
      "isLoading"
    );
  }

  handleChange = (orderId) => {
    this.getData(
      "GET",
      `/sales/C14SalesOrderItemsView?orderId=${orderId}`,
      null,
      "itemsList",
      ""
    );
  };


getSearchResult = async (keyword = "") => {
  console.log("keyword",keyword.target.value)
   this.setState({
      searchBar: keyword.target.value,
      itemsList:[]
      
    });

    this.getData(
        "GET",
        `/sales/C14SalesOrderView?keyword=${keyword.target.value}`,
        null,
        "ordersList",
        "isLoading"
      )
    
  
  };


  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  getData = async (
    method = "",
    endpoint = "",
    data = null,
    stateName = "",
    loadingStateName = ""
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      method,
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      data,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  render() {
    const { classes } = this.props;

    const tableColumnExtensions = [
      { columnName: "sn", width: 50 },
      { columnName: "jobId", width: 100 },
      { columnName: "productLabel", wordWrapEnabled: true, width: 250 },
      // { columnName: "isItemAccepted", width: 80 },
      // { columnName: "isItemConfirmed", width: 80 },
      // { columnName: "trayCode", width: 120 },
      // { columnName: "isPrintingStarted", width: 80 },
      // { columnName: "isPrintingDone", width: 80 },
      // { columnName: "isInPrintingQA", width: 100 },
      // { columnName: "isPrintingQADone", width: 100 },
      // { columnName: "isInProductionQA", width: 100 },
      // { columnName: "isProductionQADone", width: 100 },
      // { columnName: "totalProgress", width: 90 },
      // { columnName: "barcode", width: 100 },
      // { columnName: "isDispatched", width: 100 },
    ];

    const columns = [
      { name: "sn", title: "Item #" },
      { name: "jobId", title: "Job ID" },
      { name: "productLabel", title: "Item Name" },
       { name: "processTime", title: "Process Time" },
      { 
        name: "isItemAccepted", 
        title: "Item Accepted",
        getCellValue: (row) => {
          const value = row.isItemAccepted;
          return value === 1 ? (
            
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isItemConfirmed", 
        title: "Item Confirmed",
        getCellValue: (row) => {
          const value = row.isItemConfirmed;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { name: "trayCode", title: "Tray ID" },
      { 
        name: "isPrintingStarted", 
        title: "Print Started",
        getCellValue: (row) => {
          const value = row.isPrintingStarted;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isPrintingDone", 
        title: "Print Done",
        getCellValue: (row) => {
          const value = row.isPrintingDone;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isInPrintingQA", 
        title: "In Printing QA",
        getCellValue: (row) => {
          const value = row.isInPrintingQA;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isPrintingQADone", 
        title: "Printing QA Done",
        getCellValue: (row) => {
          const value = row.isPrintingQADone;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isInProductionQA", 
        title: "In Prod. QA",
        getCellValue: (row) => {
          const value = row.isInProductionQA;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { 
        name: "isProductionQADone", 
        title: "Prod. QA Completed",
        getCellValue: (row) => {
          const value = row.isProductionQADone;
          return value === 1 ? (
            <div style={{ backgroundColor: '#41D57F', padding: '8px', textAlign: 'center' }}>
              <CheckIcon className={classes.checkIcon} />
            </div>
          ) : (
            <div style={{ padding: '8px', textAlign: 'center' }}>
              <PendingIcon className={classes.pendingIconStyle} />
            </div>
          );
        }
      },
      { name: "totalProgress", title: "Order Completion %" },
      { name: "barcode", title: "Barcode" },
      { name: "isDispatched", title: "Sent To Dispatched" },
     
      
      
    ];
    // Add these to hide the extra columns



     

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
       
        <NavBar isAuthorize />
        <div className={classes.root}>
          <div className={classes.topMargin}>
            {/* <C13DeliveryOrdersStatusDashboardFilter
              state={this.state}
              handleToggleTableFilter={() => this.handleToggleTableFilter()}
              onNewItemButtonClick={() => this.onNewItemButtonClick()}
              getOrdersData={() => {
                const myCategoryId =
                  this.state.categoryId < 0 ? 0 : this.state.categoryId;
                this.getData(
                  "POST",
                  `/sales/C14SalesOrderView?isRefresh=1`,
                  null,
                  "ordersList",
                  "isLoading"
                );
              }}
            /> */}
            <Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
                      All Orders Progress
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "70%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div>
                      <Tooltip title="Refresh Orders Data">
                        <IconButton
                          style={{ marginLeft: "-10px" }}
                          onClick={() =>  this.getData(
                                    "GET",
                                    `/sales/C14SalesOrderView?isRefresh=1`,
                                    null,
                                    "ordersList",
                                    "isLoading"
                                  )
                                }
                        >
                          <RefreshIcon fontSize="default" color="primary" />
                        </IconButton>
                      </Tooltip>
                      
                    </div>
                    <div>
                      <TextField
                        label="Search By Order#"
                        variant="outlined"
                        size="small"
                        autoComplete="off"
                        required
                        fullWidth
                        name="searchBar"
                        value={this.state.searchBar}
                        onChange={(e) => this.getSearchResult(e)}
                        InputProps={{
                          classes: { input: classes.resize },
                          endAdornment: this.state.isLoading ? (
                            <div
                              style={{
                                opacity: "0.5",
                                marginRight: 5,
                              }}
                            >
                              <CircularProgress color="default" size={25} />{" "}
                            </div>
                          ) : (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  
                  </div>

                  
                </div>
              </Fragment>
          </div>
          <Divider style={{ marginTop: 5, marginBottom: 5 }} />

          <HorizontalCards 
            ordersList={this.state.ordersList}
            handleChange={this.handleChange}
          />   

          <Card className={`${classes.topMargin} ${classes.wrappedTableHeaders}`}>
            {!this.state.isLoading ? (
              <DxGridTable
                data={this.state.itemsList}
                columns={columns}
                showFilter={this.state.showTableFilter}
                isLoading={this.state.isLoading}
                tableColumnExtensions={tableColumnExtensions}
                hasActionColumn={false} // Ya is line ko omit kar dein (default false hai)
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 50,
                  width: "100%",
                  overflow: "hidden",
                  height: "90px",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Card>
        </div>
      </Fragment>
    );
  }
}

C14AllOrdersProgressDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C14AllOrdersProgressDashboard);
